var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"800px"}},_vm._l((_vm.videos),function(video,index){return _c('video',{key:index,attrs:{"width":"100%","controls":""}},[_c('source',{attrs:{"src":video.src || video,"type":video.type || 'video/mp4'}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1a17e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/answers/Videos/Videos.vue
// module id = null
// module chunks = 